import { render, staticRenderFns } from "./QuestionCheckbox.vue?vue&type=template&id=395bcb46&"
import script from "./QuestionCheckbox.vue?vue&type=script&lang=js&"
export * from "./QuestionCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports